module.exports = __webpack_public_path__ + "img/s-b.747640bd.svg";